import styled from 'styled-components';
import { Container } from './Container';

export const ContainerFluid = styled(Container)`
  max-width: 100%;
`;